import { render, staticRenderFns } from "./pdf-preview.vue?vue&type=template&id=81c02498&scoped=true"
import script from "./pdf-preview.vue?vue&type=script&lang=ts"
export * from "./pdf-preview.vue?vue&type=script&lang=ts"
import style0 from "./pdf-preview.vue?vue&type=style&index=0&id=81c02498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c02498",
  null
  
)

export default component.exports